<template>



    <div class="box">
        
            <div  class="centerbox">

            </div>
            <!-- <p @click="cup()">恭喜您已完成本次测评！</p>
             <p @click="cup()">请稍后前往<span>企业测评</span>查看结果</p> -->
           

               <p class="describe" @click="cup()">{{msg}}</p>
                <el-button type="primary" style="margin-top:30px;font-size: 23px;width:120px;" @click="return_ick" plain>返回</el-button>
           
            </div>

</template>
    
    <script>
import preventBack  from  'vue-prevent-browser-back';//组件内单独引入
export default {
    name: 'Alert',
    
    
  data() {
    return {
     mixins: [preventBack],//注入  阻止返回上一页
     msg:"",
    };
  },
  created(){
    this.msg=this.$route.query.msg
  },
        methods: {
            return_ick(){
              this.$router.push({
              name: "Signin",
            });              
            }
        }
    }
    
    </script>
    
    
    <style lang="less" scoped> 
      .box{
        height: 100%;
        width: 100% ;
        background: rgb(255, 255, 255);
       
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            font-size: 26px;
            p{
                margin-top: 30px;
           
                 line-height:45px;
                  cursor: pointer;
            }
            span{
               color:#4294f7 ; cursor: pointer;
            }
     
      }
      .centerbox{
          margin-top: -120px;
            height: 330px;
            width: 500px;
            background: url(../image/iframe/quanxian.png) no-repeat;
            background-size: 100% 100%;
            // background: red;
          
            cursor: pointer;
      }
      .hello {
  height: 100%;
  width: 100%;
 
}

    .describe{
      color: #999999;
      font-size: 32px;
    }
    
    
    </style>